export default __webpack_public_path__ + "static/media/icon-diagnosis.8da55555.svg";